const STYLES = {
  connected: ["bg-emerald-500/10 text-emerald-400 border-emerald-500/30", "bg-emerald-400"],
  ready: ["bg-emerald-500/10 text-emerald-400 border-emerald-500/30", "bg-emerald-400"],
  success: ["bg-emerald-500/10 text-emerald-400 border-emerald-500/30", "bg-emerald-400"],
  connecting: ["bg-sky-500/10 text-sky-300 border-sky-500/30", "bg-sky-300 rg-pulse"],
  reconnecting: ["bg-sky-500/10 text-sky-300 border-sky-500/30", "bg-sky-300 rg-pulse"],
  disconnected: ["bg-red-500/10 text-red-400 border-red-500/30", "bg-red-400 rg-pulse"],
  error: ["bg-red-500/10 text-red-400 border-red-500/30", "bg-red-400"],
  failure: ["bg-red-500/10 text-red-400 border-red-500/30", "bg-red-400"],
  unconfigured: ["bg-amber-500/10 text-amber-400 border-amber-500/30", "bg-amber-400"],
};

const LABELS = { unconfigured: "Not configured" };

export const StatusBadge = ({ state, label, testId }) => {
  const [cls, dot] = STYLES[state] || ["bg-slate-800 text-slate-400 border-slate-700", "bg-slate-500"];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded border px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-widest ${cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {label || LABELS[state] || state}
    </span>
  );
};
